/**
 * Field display names for each sheet – shared by Home (upload/validation) and ViewData (table headers).
 */

export const PAYLOAD_FIELD_DISPLAY_NAMES = {
  totalNo: 'Total N',
  genderMale: 'Gender Male',
  genderFemale: 'Gender Female',
  genderMissingUnknown: 'Gender Missing/unknown',
  ageAtAclrYearsLt15: 'Age <15',
  ageAtAclrYears1519: 'Age 15-19',
  ageAtAclrYears2024: 'Age 20-24',
  ageAtAclrYears2529: 'Age 25-29',
  ageAtAclrYears3034: 'Age 30-34',
  ageAtAclrYears3539: 'Age 35-39',
  ageAtAclrYearsGte40: 'Age ≥40',
  ageAtAclrYearsMissingUnknown: 'Age Missing/unknown',
  bmiLt25: 'BMI <25',
  bmi2529: 'BMI 25-29',
  bmiGte30: 'BMI ≥30',
  bmiMean: 'BMI mean',
  bmiMissingUnknown: 'BMI Missing/unknown',
  raceAsian: 'Race Asian',
  raceBlack: 'Race Black',
  raceHispanic: 'Race Hispanic',
  raceWhite: 'Race White',
  raceOther: 'Race Other',
  raceMissingUnknown: 'Race Missing/unknown',
  asa12: 'ASA 1-2',
  asaGte3: 'ASA ≥3',
  asaMissingUnknown: 'ASA Missing/unknown',
  smokingNo: 'Smoking No',
  smokingYes: 'Smoking Yes',
  smokingMissingUnknown: 'Smoking Missing/unknown',
  timeToAclr03wks: 'Time to reconstruction 0-3 wks',
  timeToAclr3wks3mo: 'Time to reconstruction 3 wks-3 mo',
  timeToAclr3mo9mo: 'Time to reconstruction 3-9 mo',
  timeToAclrGte9mo: 'Time to reconstruction ≥9 mo',
  timeToAclrMissingUnknown: 'Time to reconstruction Missing/unknown',
  operativeSideLeft: 'Operative side Left',
  operativeSideRight: 'Operative side Right',
  priorOperationNo: 'Prior operation No',
  priorOperationYes: 'Prior operation Yes',
  priorOperationMissingUnknown: 'Prior operation Missing/unknown',
  contralateralKneeNormalNo: 'Contralateral knee normal No',
  contralateralKneeNormalYes: 'Contralateral knee normal Yes',
  contralateralKneeNormalMissingUnkown: 'Contralateral knee normal Missing/unknown',
  infectionProphylaxisNo: 'Infection prophylaxis No',
  infectionProphylaxisYes: 'Infection prophylaxis Yes',
  thrombosisProphylaxisNo: 'Thrombosis prophylaxis No',
  thrombosisProphylaxisYes: 'Thrombosis prophylaxis Yes',
  operativeTimeMinutesMean: 'Operative time mean (SD)',
  operativeTimeMissingUnknown: 'Operative time Missing/unknown',
  totalNoPercent: 'Total N Percentage',
  genderMalePercent: 'Gender Male Percentage',
  genderFemalePercent: 'Gender Female Percentage',
  genderMissingUnknownPercent: 'Gender Missing/unknown Percentage',
  ageAtAclrYearsLt15Percent: 'Age <15 Percentage',
  ageAtAclrYears1519Percent: 'Age 15-19 Percentage',
  ageAtAclrYears2024Percent: 'Age 20-24 Percentage',
  ageAtAclrYears2529Percent: 'Age 25-29 Percentage',
  ageAtAclrYears3034Percent: 'Age 30-34 Percentage',
  ageAtAclrYears3539Percent: 'Age 35-39 Percentage',
  ageAtAclrYearsGte40Percent: 'Age ≥40 Percentage',
  ageAtAclrYearsMissingUnknownPercent: 'Age Missing/unknown Percentage',
  bmiLt25Percent: 'BMI <25 Percentage',
  bmi2529Percent: 'BMI 25-29 Percentage',
  bmiGte30Percent: 'BMI ≥30 Percentage',
  bmiMissingUnknownPercent: 'BMI Missing/unknown Percentage',
  raceAsianPercent: 'Race Asian Percentage',
  raceBlackPercent: 'Race Black Percentage',
  raceHispanicPercent: 'Race Hispanic Percentage',
  raceWhitePercent: 'Race White Percentage',
  raceOtherPercent: 'Race Other Percentage',
  raceMissingUnknownPercent: 'Race Missing/unknown Percentage',
  asa12Percent: 'ASA 1-2 Percentage',
  asaGte3Percent: 'ASA ≥3 Percentage',
  asaMissingUnknownPercent: 'ASA Missing/unknown Percentage',
  smokingNoPercent: 'Smoking No Percentage',
  smokingYesPercent: 'Smoking Yes Percentage',
  smokingMissingUnknownPercent: 'Smoking Missing/unknown Percentage',
  timeToAclr03wksPercent: 'Time to reconstruction 0-3 wks Percentage',
  timeToAclr3wks3moPercent: 'Time to reconstruction 3 wks-3 mo Percentage',
  timeToAclr3mo9moPercent: 'Time to reconstruction 3-9 mo Percentage',
  timeToAclrGte9moPercent: 'Time to reconstruction ≥9 mo Percentage',
  timeToAclrMissingUnknownPercent: 'Time to reconstruction Missing/unknown Percentage',
  operativeSideLeftPercent: 'Operative side Left Percentage',
  operativeSideRightPercent: 'Operative side Right Percentage',
  priorOperationNoPercent: 'Prior operation No Percentage',
  priorOperationYesPercent: 'Prior operation Yes Percentage',
  priorOperationMissingUnknownPercent: 'Prior operation Missing/unknown Percentage',
  contralateralKneeNormalNoPercent: 'Contralateral knee normal No Percentage',
  contralateralKneeNormalYesPercent: 'Contralateral knee normal Yes Percentage',
  contralateralKneeNormalMissingUnkownPercent: 'Contralateral knee normal Missing/unknown Percentage',
  infectionProphylaxisNoPercent: 'Infection prophylaxis No Percentage',
  infectionProphylaxisYesPercent: 'Infection prophylaxis Yes Percentage',
  thrombosisProphylaxisNoPercent: 'Thrombosis prophylaxis No Percentage',
  thrombosisProphylaxisYesPercent: 'Thrombosis prophylaxis Yes Percentage',
  operativeTimeMinutesMeanPercent: 'Operative time mean (SD) Percentage',
  operativeTimeMissingUnknownPercent: 'Operative time Missing/unknown Percentage'
};

export const PAYLOAD_FIELD_DISPLAY_NAMES_SHEET2 = {
  totalNo: 'Total N',
  skiingSnowboarding: 'Skiing/Snowboarding',
  altercation: 'Altercation',
  americanFootball: 'American Football',
  rugby: 'Rugby',
  baseball: 'Baseball',
  basketball: 'Basketball',
  netball: 'Netball',
  cycling: 'Cycling',
  danceGymnasticsCheer: 'Dance/Gymnastics/Cheer',
  exercisingGym: 'Exercising/Gym',
  fall: 'Fall',
  fieldHockeyLacrosse: 'Field Hockey/Lacrosse',
  floorBall: 'Floor Ball',
  frisbee: 'Frisbee',
  handball: 'Handball',
  hikingJoggingRunningWalking: 'Hiking/Jogging/Running/Walking',
  horseRidingBullRiding: 'Horse Riding/Bull Riding',
  iceHockeyBandy: 'Ice Hockey/Bandy',
  jumpingTrampoline: 'Jumping/Trampoline',
  martialArtsKampSportWrestling: 'Martial Arts/Kamp Sport/Wrestling',
  motorsportsMotorVehicleAccidentTraffic: 'Motorsports/Motor Vehicle Accident/Traffic',
  racquetSportsTennis: 'Racquet Sports/Tennis',
  rollerSkatingSkateboarding: 'Roller Skating/Skateboarding',
  soccerFootball: 'Soccer/Football',
  volleyball: 'Volleyball',
  waterSports: 'Water Sports',
  workInjury: 'Work Injury',
  otherSpareTime: 'Other Spare Time',
  other: 'Other',
  otherSport: 'Other Sport',
  missingUnknown: 'Missing/Unknown'
};

export const PAYLOAD_FIELD_DISPLAY_NAMES_SHEET3 = {
  totalNo: 'Total N',
  multiLigamentInjuryNo: 'Multi ligament injury No',
  multiLigamentInjuryYes: 'Multi ligament injury Yes',
  mclTreatmentInjuryThatWasTreated: 'Mcl Treatment Injury That Was Treated ',
  mclTreatmentInjuryThatWasNotTreated: 'MCL treatment – injury not treated',
  mclTreatmentNoInjuryTreatment: 'MCL treatment – no injury',
  lclTreatmentInjuryThatWasTreated: 'LCL treatment – injury treated',
  lclTreatmentInjuryThatWasNotTreated: 'LCL treatment – injury not treated',
  lclTreatmentNoInjuryTreatment: 'LCL treatment – no injury',
  plcTreatmentInjuryThatWasTreated: 'PLC treatment – injury treated',
  plcTreatmentInjuryThatWasNotTreated: 'PLC treatment – injury not treated',
  plcTreatmentNoInjuryTreatment: 'PLC treatment – no injury',
  pclTreatmentInjuryThatWasTreated: 'PCL treatment – injury treated',
  pclTreatmentInjuryThatWasNotTreated: 'PCL treatment – injury not treated',
  pclTreatmentNoInjuryTreatment: 'PCL treatment – no injury',
  lateralMeniscusInjuryTreatment: 'Lateral meniscus – injury/treatment',
  lateralMeniscusInjuryInjuryThatWasTreated: 'Lateral meniscus – injury treated',
  lateralMeniscusInjuryInjuryThatWasTreatedLeftSitu: 'Lateral meniscus – left situ',
  lateralMeniscusInjuryInjuryThatWasTreatedRasped: 'Lateral meniscus – rasped',
  lateralMeniscusInjuryInjuryThatWasTreatedRepair: 'Lateral meniscus – repair',
  lateralMeniscusInjuryInjuryThatWasTreatedRepBio: 'Lateral meniscus – rep bio',
  lateralMeniscusInjuryInjuryThatWasTreatedParMenis: 'Lateral meniscus – par menis',
  lateralMeniscusInjuryInjuryThatWasTreatedTrephinat: 'Lateral meniscus – trephinat',
  lateralMeniscusInjuryNoInjuryTreatment: 'Lateral meniscus – no injury',
  medialMeniscusInjuryTreatment: 'Medial meniscus – injury/treatment',
  medialMeniscusInjuryInjuryThatWasTreated: 'Medial meniscus – injury treated',
  medialMeniscusInjuryInjuryThatWasTreatedLeftSitu: 'Medial meniscus – left situ',
  medialMeniscusInjuryInjuryThatWasTreatedRasped: 'Medial meniscus – rasped',
  medialMeniscusInjuryInjuryThatWasTreatedRepair: 'Medial meniscus – repair',
  medialMeniscusInjuryInjuryThatWasTreatedRepBio: 'Medial meniscus – rep bio',
  medialMeniscusInjuryInjuryThatWasTreatedParMenis: 'Medial meniscus – par menis',
  medialMeniscusInjuryInjuryThatWasTreatedTrephinat: 'Medial meniscus – trephinat',
  medialMeniscusInjuryNoInjuryTreatment: 'Medial meniscus – no injury',
  cartilageInjuryFromTrauma: 'Cartilage – from trauma',
  cartilageInjuryOsteoarthritis: 'Cartilage – osteoarthritis',
  cartilageInjuryOther: 'Cartilage – other',
  cartilageInjuryLocationPatella: 'Cartilage location – patella',
  cartilageInjuryLocationLfc: 'Cartilage location – LFC',
  cartilageInjuryLocationLtp: 'Cartilage location – LTP',
  cartilageInjuryLocationMfc: 'Cartilage location – MFC',
  cartilageInjuryLocationMtp: 'Cartilage location – MTP',
  cartilageInjuryLocationTrochlea: 'Cartilage location – trochlea',
  cartilageInjuryThatWasTreated: 'Cartilage – that was treated',
  typeOfTreatmentDebridment: 'Type of treatment – debridment',
  typeOfTreatmentMicrofracture: 'Type of treatment – microfracture',
  typeOfTreatmentTransplant: 'Type of treatment – transplant',
  typeOfTreatmentMosaicplasty: 'Type of treatment – mosaicplasty',
  typeOfTreatmentAllograft: 'Type of treatment – allograft',
  typeOfTreatmentBiologicImplant: 'Type of treatment – biologic implant',
  typeOfTreatmentBiologicImplantName: 'Type of treatment – biologic implant name',
  typeOfTreatmentOtherTypeOfTreatment: 'Type of treatment – other',
  cartilageInjuryThatWasNotTreated: 'Cartilage – that was not treated',
  cartilageNoInjuryTreatment: 'Cartilage – no injury'
};

export const PAYLOAD_FIELD_DISPLAY_NAMES_SHEET4 = {
  totalNo: 'Total N',
  graftSelectionAllograft: 'Graft selection – Allograft',
  graftSelectionPatellaTendonAutograft: 'Graft selection – Patella tendon autograft',
  graftSelectionHamstringsTendonAtgraft: 'Graft selection – Hamstrings tendon autograft',
  graftSelectionHamstringsTendonAtgraftGracillis: 'Graft selection – Hamstrings tendon autograft + Gracillis',
  graftSelectionHamstringsTendonAtgraftSemiT: 'Graft selection – Hamstrings tendon autograft Semi-T',
  graftSelectionHamstringsTendonAtgraftSemiTGracilis: 'Graft selection – Hamstrings tendon autograft Semi-T + Gracilis',
  graftSelectionQuadricepsTendonAtgraft: 'Graft selection – Quadriceps tendon autograft',
  graftSelectionHybridGraft: 'Graft selection – Hybrid graft',
  graftSelectionSyntheticGraft: 'Graft selection – Synthetic graft',
  graftSelectionOtherGraft: 'Graft selection – Other graft',
  graftSelectionMissingUnknown: 'Graft selection – Missing/unknown',
  numberOfStrands2: 'Number of strands – 2',
  numberOfStrands3: 'Number of strands – 3',
  numberOfStrands4: 'Number of strands – 4',
  numberOfStrands5: 'Number of strands – 5',
  numberOfStrands6: 'Number of strands – 6',
  numberOfStrands7: 'Number of strands – 7',
  numberOfStrands8: 'Number of strands – 8',
  numberOfStrandsMissingUnknown: 'Number of strands – Missing/unknown',
  graftDiameter6mm: 'Graft diameter – 6 mm',
  graftDiameter65mm: 'Graft diameter – 6.5 mm',
  graftDiameter7mm: 'Graft diameter – 7 mm',
  graftDiameter75mm: 'Graft diameter – 7.5 mm',
  graftDiameter8mm: 'Graft diameter – 8 mm',
  graftDiameter85mm: 'Graft diameter – 8.5 mm',
  graftDiameter9mm: 'Graft diameter – 9 mm',
  graftDiameter95mm: 'Graft diameter – 9.5 mm',
  graftDiameter10mm: 'Graft diameter – 10 mm',
  graftDiameter105mm: 'Graft diameter – 10.5 mm',
  graftDiameter11mm: 'Graft diameter – 11 mm',
  graftDiameter115mm: 'Graft diameter – 11.5 mm',
  graftDiameter12mm: 'Graft diameter – 12 mm',
  graftDiameter125mm: 'Graft diameter – 12.5 mm',
  graftDiameterMissingUnknown: 'Graft diameter – Missing/unknown',
  lateralExtraarticularProcedureTypeAll: 'Lateral extra-articular procedure – All',
  lateralExtraarticularProcedureTypeLet: 'Lateral extra-articular procedure – LET',
  lateralExtraarticularProcedureTypeOther: 'Lateral extra-articular procedure – Other',
  syntheticAugmentation: 'Synthetic augmentation',
  aclRepairFemoralFixationCombination: 'ACL femoral fixation – Combination',
  aclRepairFemoralFixationCrosspin: 'ACL femoral fixation – Crosspin',
  aclRepairFemoralFixationInterference: 'ACL femoral fixation – Interference',
  aclRepairFemoralFixationSuspensory: 'ACL femoral fixation – Suspensory',
  aclRepairFemoralFixationUnknownNotRecorded: 'ACL femoral fixation – Unknown/not recorded',
  aclRepairFemoralFixationMaterialBioabsorbable: 'ACL femoral fixation material – Bioabsorbable',
  aclRepairFemoralFixationMaterialMetal: 'ACL femoral fixation material – Metal',
  aclRepairFemoralFixationMaterialPeek: 'ACL femoral fixation material – PEEK',
  aclRepairFemoralFixationMaterialUnknownNotRecorded: 'ACL femoral fixation material – Unknown/not recorded',
  aclRepairTibialFixationCombination: 'ACL tibial fixation – Combination',
  aclRepairTibialFixationInterference: 'ACL tibial fixation – Interference',
  aclRepairTibialFixationSuspensory: 'ACL tibial fixation – Suspensory',
  aclRepairTibialFixationMissingUnknown: 'ACL tibial fixation – Missing/unknown',
  aclRepairTibialFixationMaterialBioabsorbable: 'ACL tibial fixation material – Bioabsorbable',
  aclRepairTibialFixationMaterialMetal: 'ACL tibial fixation material – Metal',
  aclRepairTibialFixationMaterialPeek: 'ACL tibial fixation material – PEEK',
  aclRepairTibialFixationMaterialMissingUnknown: 'ACL tibial fixation material – Missing/unknown',
  aclRepairFemoralTunnelDrillTechnAnteromedialPortal: 'Femoral tunnel drill – Anteromedial portal',
  aclRepairFemoralTunnelDrillTechnOutsideInApproach: 'Femoral tunnel drill – Outside-in',
  aclRepairFemoralTunnelDrillTechnTransTibial: 'Femoral tunnel drill – Trans-tibial',
  aclRepairFemoralTunnelDrillTechnMissingUnknown: 'Femoral tunnel drill – Missing/unknown'
};

export const PAYLOAD_FIELD_DISPLAY_NAMES_SHEET5 = {
  totalNo: 'Total N',
  followUpTimeInYearsMedianIqr: 'Follow-up time in years (median, IQR)',
  cumulativeRevisionAt2Years: 'Cumulative revision at 2 years',
  cumulativeRevisionAt5Years: 'Cumulative revision at 5 years',
  cumulativeRevisionAt10Years: 'Cumulative revision at 10 years',
  cumulativeIpsilateralReoperationAt2Years: 'Cumulative ipsilateral reoperation at 2 years',
  cumulativeIpsilateralReoperationAt5Years: 'Cumulative ipsilateral reoperation at 5 years',
  cumulativeIpsilateralReoperationAt10Years: 'Cumulative ipsilateral reoperation at 10 years',
  contralateralKneeOperationsAt2Years: 'Contralateral knee operations at 2 years',
  contralateralKneeOperationsAt5Years: 'Contralateral knee operations at 5 years',
  contralateralKneeOperationsAt10Years: 'Contralateral knee operations at 10 years',
  deathAt2Years: 'Death at 2 years',
  deathAt5Years: 'Death at 5 years',
  deathAt10Years: 'Death at 10 years',
  lostToFollowUpAt2Years: 'Lost to follow-up at 2 years',
  lostToFollowUpAt5Years: 'Lost to follow-up at 5 years',
  lostToFollowUpAt10Years: 'Lost to follow-up at 10 years'
};

export const PAYLOAD_FIELD_DISPLAY_NAMES_SHEET6 = {
  
  koosSubscaleMeanSd: 'KOOS subscale mean (SD)',
  koosSubscalePreoperativeTotalN: 'KOOS preoperative – Total N',
  koosSubscalePreoperativePain: 'KOOS preoperative – Pain',
  koosSubscalePreoperativeSymptoms: 'KOOS preoperative – Symptoms',
  koosSubscalePreoperativeActiviDailLiv: 'KOOS preoperative – Activities daily living',
  koosSubscalePreoperativeSportsRecreation: 'KOOS preoperative – Sports/recreation',
  koosSubscalePreoperativeQualityOfLife: 'KOOS preoperative – Quality of life',
  koosSubscaleAt1YearPostoperativeTotalN: 'KOOS 1 year – Total N',
  koosSubscaleAt1YearPostoperativePain: 'KOOS 1 year – Pain',
  koosSubscaleAt1YearPostoperativeSymptoms: 'KOOS 1 year – Symptoms',
  koosSubscaleAt1YearPostoperativeActiviDailLiv: 'KOOS 1 year – Activities daily living',
  koosSubscaleAt1YearPostoperativeSportsRecreat: 'KOOS 1 year – Sports/recreation',
  koosSubscaleAt1YearPostoperativeQualityOfLife: 'KOOS 1 year – Quality of life',
  koosSubscaleAt2YearPostoperativeTotalN: 'KOOS 2 year – Total N',
  koosSubscaleAt2YearPostoperativePain: 'KOOS 2 year – Pain',
  koosSubscaleAt2YearPostoperativeSymptoms: 'KOOS 2 year – Symptoms',
  koosSubscaleAt2YearPostoperativeActiviDailLiv: 'KOOS 2 year – Activities daily living',
  koosSubscaleAt2YearPostoperativeSportsRecreat: 'KOOS 2 year – Sports/recreation',
  koosSubscaleAt2YearPostoperativeQualityOfLife: 'KOOS 2 year – Quality of life',
  koosSubscaleAt5YearPostoperativeTotalN: 'KOOS 5 year – Total N',
  koosSubscaleAt5YearPostoperativePain: 'KOOS 5 year – Pain',
  koosSubscaleAt5YearPostoperativeSymptoms: 'KOOS 5 year – Symptoms',
  koosSubscaleAt5YearPostoperativeActiviDailLiv: 'KOOS 5 year – Activities daily living',
  koosSubscaleAt5YearPostoperativeSportsRecreat: 'KOOS 5 year – Sports/recreation',
  koosSubscaleAt5YearPostoperativeQualityOfLife: 'KOOS 5 year – Quality of life',
  koosSubscaleAt10YearPostoperativeTotalN: 'KOOS 10 year – Total N',
  koosSubscaleAt10YearPostoperativePain: 'KOOS 10 year – Pain',
  koosSubscaleAt10YearPostoperativeSymptoms: 'KOOS 10 year – Symptoms',
  koosSubscaleAt10YearPostoperativeActiviDailLiv: 'KOOS 10 year – Activities daily living',
  koosSubscaleAt10YearPostoperativeSportsRecreat: 'KOOS 10 year – Sports/recreation',
  koosSubscaleAt10YearPostoperativeQualityOfLife: 'KOOS 10 year – Quality of life',
  eq5dIndexMeanSd: 'EQ-5D index mean (SD)',
  eq5dPreoperativeTotalN: 'EQ-5D preoperative – Total N',
  eq5dPreoperativeMobility: 'EQ-5D preoperative – Mobility',
  eq5dPreoperativeSelfCare: 'EQ-5D preoperative – Self-care',
  eq5dPreoperativeUsualActivities: 'EQ-5D preoperative – Usual activities',
  eq5dPreoperativePainDiscomfort: 'EQ-5D preoperative – Pain/discomfort',
  eq5dPreoperativeAnxietyDepression: 'EQ-5D preoperative – Anxiety/depression',
  eq5dAt1YearPostoperativeTotalN: 'EQ-5D 1 year – Total N',
  eq5dAt1YearPostoperativeMobility: 'EQ-5D 1 year – Mobility',
  eq5dAt1YearPostoperativeSelfCare: 'EQ-5D 1 year – Self-care',
  eq5dAt1YearPostoperativeUsualActivities: 'EQ-5D 1 year – Usual activities',
  eq5dAt1YearPostoperativePainDiscomfort: 'EQ-5D 1 year – Pain/discomfort',
  eq5dAt1YearPostoperativeAnxietyDepression: 'EQ-5D 1 year – Anxiety/depression',
  eq5dAt2YearsPostoperativeTotalN: 'EQ-5D 2 years – Total N',
  eq5dAt2YearsPostoperativeMobility: 'EQ-5D 2 years – Mobility',
  eq5dAt2YearsPostoperativeSelfCare: 'EQ-5D 2 years – Self-care',
  eq5dAt2YearsPostoperativeUsualActivities: 'EQ-5D 2 years – Usual activities',
  eq5dAt2YearsPostoperativePainDiscomfort: 'EQ-5D 2 years – Pain/discomfort',
  eq5dAt2YearsPostoperativeAnxietyDepression: 'EQ-5D 2 years – Anxiety/depression',
  eq5dAt5YearsPostoperativeTotalN: 'EQ-5D 5 years – Total N',
  eq5dAt5YearsPostoperativeMobility: 'EQ-5D 5 years – Mobility',
  eq5dAt5YearsPostoperativeSelfCare: 'EQ-5D 5 years – Self-care',
  eq5dAt5YearsPostoperativeUsualActivities: 'EQ-5D 5 years – Usual activities',
  eq5dAt5YearsPostoperativePainDiscomfort: 'EQ-5D 5 years – Pain/discomfort',
  eq5dAt5YearsPostoperativeAnxietyDepression: 'EQ-5D 5 years – Anxiety/depression',
  eq5dAt10YearsPostoperativeTotalN: 'EQ-5D 10 years – Total N',
  eq5dAt10YearsPostoperativeMobility: 'EQ-5D 10 years – Mobility',
  eq5dAt10YearsPostoperativeSelfCare: 'EQ-5D 10 years – Self-care',
  eq5dAt10YearsPostoperativeUsualActivities: 'EQ-5D 10 years – Usual activities',
  eq5dAt10YearsPostoperativePainDiscomfort: 'EQ-5D 10 years – Pain/discomfort',
  eq5dAt10YearsPostoperativeAnxietyDepression: 'EQ-5D 10 years – Anxiety/depression'
};

export const SHEET_FIELD_DISPLAY_MAP = {
  tblpatientcharacteristics: PAYLOAD_FIELD_DISPLAY_NAMES,
  tblinjurymechanism: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET2,
  tblconcurrentinjuries: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET3,
  tblconcurrentinjury: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET3,
  tblgraftselection: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET4,
  tbloutcomesaclr: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET5,
  tblpatientreportedoutcome: PAYLOAD_FIELD_DISPLAY_NAMES_SHEET6
};

/**
 * Get human-readable title for a field key from display names.
 * @param {string} key - Field key (e.g. totalNo, genderMalePercent)
 * @param {string} [sheetKey] - Sheet key (e.g. tblpatientcharacteristics). If omitted, searches all sheet maps.
 * @returns {string} Display title or empty string if not found
 */
export function getFieldDisplayName(key, sheetKey) {
  if (!key) return '';
  if (sheetKey) {
    const map = SHEET_FIELD_DISPLAY_MAP[sheetKey];
    return (map && map[key]) || '';
  }
  for (const map of Object.values(SHEET_FIELD_DISPLAY_MAP)) {
    if (map && map[key]) return map[key];
  }
  return '';
}

export const SHEET_OPTIONS = [
  { value: 'tblpatientcharacteristics', label: 'Patient characteristics' },
  { value: 'tblinjurymechanism', label: 'Injury mechanism' },
  { value: 'tblconcurrentinjury', label: 'Concurrent injury' },
  { value: 'tblgraftselection', label: 'Graft selection' },
  { value: 'tbloutcomesaclr', label: 'Outcomes ACL-R' },
  { value: 'tblpatientreportedoutcome', label: 'Patient reported outcome' }
];
